import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ROOT_ROUTES } from './core/configurations/router.config';
import { authGuard } from './core/guards/auth.guard';
import { EmptyComponent } from './shared/components/empty/empty.component';
import { signInGuard } from './core/guards/sign-in.guard';
import { AuthorizedRoutingModule } from './authorized-routing.module';

const routes: Routes = [
  {
    path: ROOT_ROUTES.signIn,
    component: EmptyComponent,
    canMatch: [signInGuard],
  },
  {
    path: '',
    canMatch: [authGuard],
    loadChildren: (): Promise<typeof AuthorizedRoutingModule> =>
      import('./authorized-routing.module').then((module) => module.AuthorizedRoutingModule),
  },
  {
    path: '**',
    redirectTo: ROOT_ROUTES.notFound,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
